import {Component, Inject, OnInit} from '@angular/core';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {NotificationService} from '@app/services/notification/notification.service';
import {ConstantsService} from '@app/services/constants/constants.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {NewTaskModalComponent} from '@components/my-web-desk/new-task-modal/new-task-modal.component';
import {ToastrService} from 'ngx-toastr';
import {ActivityService} from '@components/my-web-desk/my-web-desk-sidebar/sidebar-content/sidebar-content-activity-center/activity-service.service';
import {BackendResponse} from '@app/interfaces/backendResponse';


@Component({
    selector: 'app-new-activity-dialog',
    templateUrl: './new-activity-dialog.component.html',
    styleUrls: ['./new-activity-dialog.component.css']
})
export class NewActivityDialogComponent implements OnInit {

    constructor(private taskService: TaskService,
                @Inject(MAT_DIALOG_DATA) public dialogData: any,
                private notifyService: NotificationService,
                public constants: ConstantsService,
                public dialogRef: MatDialogRef<NewActivityDialogComponent>,
                public formBuilder: FormBuilder,
                private datePipe: DatePipe,
                private dialog: MatDialog,
                private toastr: ToastrService,
                private activityService: ActivityService
    ) {
    }

    public DateObj = new Date();
    public DateObj1 = new Date();

    assignedTasks = [];
    allTasks = [];
    taskId: string = '';
    activityId: string = '';

    form = new FormGroup({});
    task = new FormControl('');

    startDate = new FormControl('', Validators.required);
    endDate = new FormControl('', Validators.required);
    startTime = new FormControl('', Validators.required);
    endTime = new FormControl('', Validators.required);
    mode = 'new';
    projects = [];
    emptyProject = false;
    data: any = {};

    searchText = '';
    searchText1 = '';

    taskData: any = {};
    loader = false;

    project: string = '';
    projectFormValidate = new FormControl('', Validators.required);
    buttonDisabled = false;
    type: any = {name: 'Posao', value: 'Bussiness'};

    modalTitle = 'Dodavanje nove aktivnosti';
    selectedType = {name: 'Posao', value: 'Bussiness'};


    types = [{name: 'Posao', value: 'Bussiness'},
        {name: 'Pauza', value: 'Break'},
        {name: 'Lični izlazak', value: 'Personal'},
        {name: 'Ostalo', value: 'Other'}];

    activity = {
        id: '',
        startDate: {
            year: this.DateObj.getFullYear(),
            month: this.DateObj.getMonth() + 1,
            day: this.DateObj.getDate()
        },
        endDate: {
            year: this.DateObj1.getFullYear(),
            month: this.DateObj1.getMonth() + 1,
            day: this.DateObj1.getDate()
        },
        startTime: {hour: this.DateObj.getHours(), minute: this.DateObj.getMinutes()},
        endTime: {hour: this.DateObj.getHours(), minute: this.DateObj.getMinutes()},
        description: '',
        taskId: '',
        project: '',
        sort: '',
        type: this.type
    };

    async ngOnInit() {
        this.form = new FormGroup({
            actStartDate: this.startDate,
            actEndDate: this.endDate,
            actStartTime: this.startTime,
            actEndTime: this.endTime,
            // type: new FormControl({name: 'Posao', value: 'Bussiness'})
        });

        this.getProjects();
        await this.getAlltasks();
        if (this.dialogData.mode === 'edit' || this.dialogData.mode == 'edit_automatic_activity') {
            this.mode = this.dialogData.mode;

            let activity = this.dialogData.data;
            let start = new Date(activity.start);
            let end = new Date(activity.end);
            this.data = activity;
            this.type = activity.type;
            this.project = activity.project_id;
            if (activity.project_id !== null) {
                this.assignedTasks = this.assignedTasks.filter(x => x.project_id === activity.project_id);
            }
            let project = this.projects.find(x => x._id === activity.project_id);
            this.taskData = this.assignedTasks.find(x => x._id === activity.task_id);
            if (activity.task !== null) {
                this.taskData = activity.task;
                this.task.setValue(activity.task.title);
                this.searchText1 = (activity.task.title);
                if (activity.project_id !== null && activity.project_id !== '') {
                    this.searchText = activity.project.name;
                }
            }


            this.activityId = activity._id;
            this.taskId = activity.task_id;
            this.project = activity.project_id;
            this.activity = {
                id: this.activityId,
                startDate: {
                    year: start.getFullYear(),
                    month: start.getMonth() + 1,
                    day: start.getDate()
                },
                endDate: {
                    year: end.getFullYear(),
                    month: end.getMonth() + 1,
                    day: end.getDate()
                },
                startTime: {hour: start.getHours(), minute: start.getMinutes()},
                endTime: {hour: end.getHours(), minute: end.getMinutes()},
                description: activity.comment,
                taskId: activity.taskId,
                project: activity.project_id,
                sort: activity.sort,
                type: this.type
            };
            this.loader = true;
        } else if (this.dialogData.mode === 'new') {
            this.activity.startDate = this.dialogData?.data?.date;
            this.activity.endDate = this.dialogData?.data?.date;
            this.loader = true;
        } else {
            this.loader = true;
        }


    }


    async getAlltasks() {
        await this.taskService.getAll().subscribe(result => {
            this.assignedTasks = result;
            this.allTasks = result;
        });
    }

    getProjects() {
        this.taskService.getProjects().subscribe(result => {
            this.projects = result;
        });
    }


    public findInvalidControls() {
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }

    }

    addActivity() {
        this.emptyProject = false;
        this.buttonDisabled = true;
        const start = new Date(this.activity.startDate.year +
            '-' + this.activity.startDate.month + '-' +
            this.activity.startDate.day + ' ' + this.activity.startTime.hour + ':' + this.activity.startTime.minute);
        const end = new Date(this.activity.endDate.year +
            '-' + this.activity.endDate.month + '-' +
            this.activity.endDate.day + ' ' + this.activity.endTime.hour + ':' + this.activity.endTime.minute);
        this.findInvalidControls();
        if ( this.project === '' && this.type.name == "Posao" )
        {
          this.emptyProject = true;
          this.toastr.info('Polje projekat je obavezno. Molimo vas popunite polje.');
          this.buttonDisabled = false;
          return;
        }
        if (this.form.invalid) {
            this.toastr.info('Molimo Vas popunite obavezna polja.');
            this.buttonDisabled = false;
            return;
        } else if (this.taskData !== undefined && Object.keys(this.taskData).length !== 0) {
            if (this.taskData.project_id !== null) {
                if (this.taskData.project_id !== this.project && this.taskId !== '') {
                    this.toastr.info('Izabrani zadatak ne pripada izabranom projektu.');
                    this.buttonDisabled = false;
                    return;
                }
            } else if (this.taskData.project_id == null && this.project !== '' && this.project !== null) {
                this.toastr.info('Izabrani zadatak ne pripada izabranom projektu.');
                this.buttonDisabled = false;
                return;
            }
            if (start > end) {
                this.toastr.info('Početak aktivnosti mora biti manji od završetka.');
                this.buttonDisabled = false;
                return;
            }

            if ((start.toString() === end.toString())) {
                this.toastr.info('Vrijeme početka mora biti različito od završetka.');
                this.buttonDisabled = false;
                return;
            }

        } else if (start > end) {
            this.toastr.info('Početak aktivnosti mora biti manji od završetka.');
            this.buttonDisabled = false;
            return;
        } else if ((start.toString() === end.toString())) {
            this.toastr.info('Vrijeme početka mora biti različito od završetka.');
            this.buttonDisabled = false;
            return;
        }

        this.activity = {
            id: this.activityId,
            startDate: {
                year: this.activity.startDate.year,
                month: this.activity.startDate.month,
                day: this.activity.startDate.day
            },
            endDate: {
                year: this.activity.endDate.year,
                month: this.activity.endDate.month,
                day: this.activity.endDate.day
            },
            startTime: {hour: this.activity.startTime.hour, minute: this.activity.startTime.minute},
            endTime: {hour: this.activity.endTime.hour, minute: this.activity.endTime.minute},
            description: this.activity.description,
            taskId: this.taskId !== undefined ? this.taskId : '',
            project: this.project,
            sort: this.taskId !== '' ? this.taskData['sort'] : '',
            type: this.type
        };
        if (this.mode == 'edit_automatic_activity') {
            if ((this.activity.description == "" && this.activity.taskId == '' && this.activity.project == null) && (this.type.value !== 'Other' && this.type.value !== 'Break')) {
                this.toastr.info('Molimo Vas unesite sve detalje aktivnosti.');
                this.buttonDisabled = false;
                return;
            } else {
                this.activityService.addActivity(this.activity, 'new').subscribe((response: BackendResponse) => {
                    if (response['type'] === 'success') {
                        this.toastr.success('Uspješno dodata aktivnost.');
                        this.buttonDisabled = false;
                        this.dialogRef.close();
                    } else {
                        this.toastr.error('Došlo je do greške prilikom čuvanja aktivnosti. Molimo Vas obratiite se korisničkoj podršci.');
                    }
                }, error => {
                    
                });
            }


        } else {
            this.activityService.addActivity(this.activity, this.mode).subscribe((response: BackendResponse) => {
                if (response['type'] === 'success') {
                    this.toastr.success('Uspješno dodata aktivnost.');
                    this.buttonDisabled = false;
                    this.dialogRef.close();
                } else {
                    this.toastr.error('Došlo je do greške prilikom čuvanja aktivnosti. Molimo Vas obratiite se korisničkopj podršci.');
                }
            }, error => {
                
            });
        }


    }

    close() {
        this.dialogRef.close();
    }

    getTask(data) {
        this.taskId = data._id;
        this.taskData = data;
        if (data.project !== null) {
            this.project = data.project_id;
            this.data = {project: data.project};
        }

    }


    openModal() {
        this.dialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                mode: 'new',
                task: null,
                sort: 'task'
            }
        }).afterClosed().subscribe((data) => {
            if (data === true) {
                setTimeout(() => {
                    this.getAlltasks();
                }, 1000);
            }
        });
    }

    getProjectFromChild(data) {
        if (Object.keys(data).length !== 0 && data !== undefined) {
            this.project = data._id;
            this.assignedTasks = this.assignedTasks.filter(p => (p.project !== null && p.project.name === data.name));
        } else {
            this.project = '';
            this.assignedTasks = this.allTasks;
        }
    }

    checkTask() {
        this.taskData = {};
        if (this.taskId == '' && (this.project == '' || this.project == null)) {
            this.data = {project: {name: '', _id: ''}};
        } else if (this.taskId !== '' && this.taskData.project_id !== this.project) {
            // this.project = '';
        }
        this.taskId = '';
    }

    changeType(event) {
        this.type = this.types.find(x => x.value == event.target.value);
    }

}
